  export const validateName = (name) => {
    const nameRegex = /^[A-Za-z\s]+$/;
    if (!name.trim()) {
      return "Name is required.";
    }
    if (!nameRegex.test(name)) {
      return "Enter Valid Name.";
    }
    if (name.trim().length < 2) {
      return "Name should be at least 2 characters long.";
    }
    return null;
  };

  export const validateEmail = (email) => {
    const emailRegex = /^[a-zA-Z0-9._-]+@nucleusteq\.com$/;
    if (!email.trim()) {
      return "Email is required.";
    }
    if (!emailRegex.test(email)) {
      return "Email must end with @nucleusteq.com";
    }
    return null;
  };

 export const validatePassword = (password) => {
  if (!password) {
    return "Password is required.";
  }
  if (password.length < 6) {
    return "Password must be at least 6 characters long.";
  }
  
  // Check for at least one uppercase letter
  const hasUpperCase = /[A-Z]/.test(password);
  if (!hasUpperCase) {
    return "Password must contain at least one uppercase letter.";
  }
  
  // Check for at least one special character
  const hasSpecialChar = /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/.test(password);
  if (!hasSpecialChar) {
    return "Password must contain at least one special character.";
  }
  
  return null;
};

  export const validateEmpId = (empId) => {
    if (!empId.trim()) {
      return "Employee ID is required.";
    }
    if (empId.trim().length < 3) {
      return "Employee ID should be at least 3 characters long.";
    }
    return null;
  };